<template lang="pug">
  b-form(@submit.prevent='submit')
    b-btn.checklist-item-toggle.text-left.mt-3(block href='#' v-b-toggle="'accordion' + index" :variant='itemColorVariant()')
      .item-status
        small(v-if='item.defective') Defect
      span.text-left {{ item.name ? item.name : "New inspection-item" }}
      i.icon-arrow-down.accordion-icon
    b-collapse(:id="'accordion' + index" :accordion="'accordion' + index" role='tabpanel')
      b-card
        b-card-body
          b-row
            b-col.item-delete.text-right.text-danger.pb-4(sm='12')
              template(v-if='canShowRemove()')
                a(@click='removeCurrentItem(index)')
                  span REMOVE ITEM
                  i.icon-close.pl-2
          b-row
            b-col(sm='7')
              b-form-fieldset(label='Part')
                b-form-input(
                  type='text',
                  :id="'checklist_item_part' + index"
                  :name="'part' + index"
                  placeholder="Enter inspection-item's part"
                  v-model='item.name'
                  v-validate= "'required'"
                )
                div.text-danger(v-show="errors.has('item.name')") {{ errors.first('item.name') }}
            b-col(sm='5')
              b-row
                b-col(sm='12')
                  b-form-fieldset(label='ID')
                    b-form-input(
                      type='text',
                      :id="'checklist_item_component_name' + index"
                      :name="'component_name' + index"
                      placeholder="Enter component's ID"
                      v-model='item.component_name'
                    )
              b-row.pt-2(v-if='item.id')
                b-col(sm='12')
                  b-row
                    b-col(sm='12')
                      c-switch.mr-3(
                        type='icon'
                        variant='danger'
                        v-bind="{on: '\uf00c', off: '\uf00d'}"
                        :checked='item.defective'
                        @change='handleDefectiveChange'
                      )
                      span The component has defects
          b-row(v-if='item.id')
            b-col(sm='12')
              b-form-fieldset(label='Notes')
                b-form-textarea(
                  :id="'checklist_item_notes' + index"
                  :name="'notes' + index"
                  placeholder='Write the notes here'
                  rows='5'
                  v-model='item.notes'
                )
          b-row(v-if='item.id')
            b-col(sm='6')
              b-form-fieldset(label='Grid of inspection')
                b-form-textarea(
                  :id="'checklist_item_grid_of_inspection' + index"
                  :name="'grid_of_inspection' + index"
                  placeholder='Write the grid of inspection here'
                  rows='4'
                  v-model='item.grid_of_inspection'
                )
            b-col(sm='6')
              b-form-fieldset(label='Instrumental settings')
                b-form-textarea(
                  :id="'checklist_item_instrumental_settings' + index"
                  :name="'instrumental_settings' + index"
                  placeholder='Write the instrumental settings here'
                  rows='4'
                  v-model='item.instrumental_settings'
                )
          b-row(v-if='item.id')
            b-col(sm='12')
              b-form-fieldset(label='Photos')
                c-uppy(
                  :uppyId="'uppy-' + index"
                  @on-success='setItemPhotos'
                )
          b-row(v-if='item.id')
            b-col(sm='12')
              b-container.pb-4.pt-2.px-0(fluid)
                b-row
                  template(v-for='(value, key) in item.photo_urls')
                    b-col.gallery-thumbnail(sm='4')
                      .gallery-thumbnail__element
                        a(:href='value' target='_blank')
                          b-img.gallery-thumbnail__element__img(thumbnail fluid :src='value')
                          i.icon-eye.gallery-thumbnail__element__icon
                      .gallery-thumbnail__remove.text-center.my-2
                        b-button(type='button' variant='danger' @click='removeImg(key)')
                          i.icon-close.pr-2
                          span REMOVE
          b-row.py-3(v-if='item.id')
            b-col(sm='12')
              h3.text-center Reports
          b-row.py-3(v-if='item.id')
            b-col.text-center(sm='6')
              b-form-fieldset(v-if='canUploadDraftReport()' label='Draft Report')
                i.small {{ draftReportInfo.notes }}
                c-uppy.py-2(
                  :uppyProps='uppyDoc'
                  :uppyId="'uppyDraft-' + index"
                  :fileTypes='draftReportInfo.types'
                  :uppySize='25000000'
                  @on-success='setItemDraftReport'
                )
                template(v-if='item.draft_report')
                  a.report-link(:href='item.draft_report_url')
                    strong.text-success
                      i.icon-cloud-download.pr-2
                      span Download Draft report
              .text-danger(v-if='!canUploadDraftReport()')
                b.mb-0 {{ item.checker.full_name + ' ' + item.checker.email }}
                p has already loaded a draft report

            b-col.text-center(sm='6')
              b-form-fieldset(v-if='canUploadFinalReport()' label='Final Report')
                i.small {{ finalReportInfo.notes }}
                c-uppy.py-2(
                  :uppyProps='uppyDoc'
                  :uppyId="'uppyFinal-' + index"
                  :fileTypes='finalReportInfo.types'
                  :uppySize='25000000'
                  @on-success='setItemFinalReport'
                )
                template(v-if='item.final_report')
                  a.report-link(:href='item.final_report_url' target='_blank')
                    strong.text-success
                      i.icon-cloud-download.pr-2
                      span Download Final report
              template(v-if='!canUploadFinalReport()')
                p.text-danger You can't upload a final report!

          b-row.pt-2(v-if='item.id')
            b-col(sm='6' v-if='item.draft_report || item.final_report')
              b-form-fieldset(label='Report number')
                b-form-input(
                  type='text',
                  :id="'checklist_item_report_number' + index"
                  name='report_number'
                  placeholder="Enter the report number"
                  v-model='item.report_number'
                  v-validate= 'validations.reportNumber'
                )
                div.text-danger(v-show="errors.has('report_number')") {{ errors.first('report_number') }}
            b-col(sm='6')
              b-form-fieldset(label='Completion date check')
                b-form-input(
                  type='date'
                  id='checklistItem_checked_at'
                  name='checked_at'
                  v-model='item.checked_at'
                  :disabled='!canUploadDraftReport()'
                  v-validate= "'required'"
                )
                div.text-danger(v-show="errors.has('checked_at')") {{ errors.first('checked_at') }}

          b-row.py-2
            b-col(sm='3')
              button.btn.btn-primary.px-4(type='submit') Save
</template>

<script>
  import server from '@/server'
  import Policeman from '@/utils/Policeman/policeman'
  import Messages from '@/utils/notificationsMsg'
  import RouteGen from '@/utils/apiRoutes'
  import cUppy from '@/components/Shared/Uppy'
  import cSwitch from '@/components/Shared/Switch'

  import { mapGetters } from 'vuex'

  export default {
    name: 'EditItem',
    components: { cUppy, cSwitch },
    data () {
      return {
        validations: {
          reportNumber: ''
        },
        uppyDoc: {
          dashboard: false,
          s3: true,
          input: true,
          statusBar: true
        },
        draftReportInfo: {
          notes: 'Allowed files: *.doc, *.docx, *.xls, *.xlsx, *.odt, *.ods',
          types: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
            'application/vnd.ms-excel',
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.oasis.opendocument.text',
            'application/vnd.oasis.opendocument.spreadsheet',
            'application/x-msi'
          ]
        },
        finalReportInfo: {
          notes: 'Allowed files: *.pdf',
          types: [
            'application/pdf'
          ]
        },
        item: {
          photo_urls: {}
        }
      }
    },
    props: {
      index: {
        type: Number,
        default: null
      },
      checklistItem: {
        type: Object,
        default: {}
      }
    },
    computed: {
      ...mapGetters({
        currentUser: 'currentUser'
      })
    },
    mounted () {
      this.$set(this.$data, 'item', this.checklistItem)
      this.changeReportNumberRules()
    },
    watch: {
      item () {
        this.$emit('update-item-data', { item: this.item, index: this.index })
      },
      draft_report () {
        this.changeReportNumberRules()
      }
    },
    methods: {
      itemColorVariant () {
        if (this.item.defective) { return 'danger' }
        return 'primary'
      },
      canShowRemove () {
        if (!this.item.id) {
          return true
        } else if (Policeman.can('delete', 'checklistItem')) {
          return true
        } else {
          return false
        }
      },
      canUploadFinalReport () {
        if (Policeman.can('delete', 'checklistItem') && Policeman.authorize(['admin'])) { return true }
        return false
      },
      changeReportNumberRules () {
        if (this.item.draft_report) {
          if (this.item.draft_report.length) {
            this.$set(this.$data.validations, 'reportNumber', 'required')
          } else {
            this.$set(this.$data.validations, 'reportNumber', '')
          }
        }
      },
      canUploadDraftReport () {
        if (Policeman.can('edit', 'checklistItem')) {
          if (!this.item.checked || Policeman.authorize(['admin'])) { return true }
          let checkerEmail = this.item.checker.email
          let checkerId = this.item.checker.id
          if (this.currentUser.email === checkerEmail && this.currentUser.id === checkerId) { return true }
        }
        return false
      },
      isEdit () {
        return this.$route.params.hasOwnProperty('id')
      },
      handleCheckedChange (status) {
        this.$set(this.item, 'checked', status)
      },
      handleDefectiveChange (status) {
        this.$set(this.item, 'defective', status)
      },
      setItemPhotos (files) {
        let currentPhotos = this.$data.item.photos ? this.$data.item.photos : []
        files.successful.map((file) => {
          currentPhotos.push(file.id + '.' + file.extension)
        })
        this.$set(this.$data.item, 'photos', currentPhotos)
      },
      setItemDraftReport (draft) {
        this.$set(
          this.$data.item,
          'draft_report',
          draft.successful[0].id + '.' + draft.successful[0].extension
        )
      },
      setItemFinalReport (final) {
        this.$set(
          this.$data.item,
          'final_report',
          final.successful[0].id + '.' + final.successful[0].extension
        )
      },
      removeImg (key) {
        this.$delete(this.item.photo_urls, key)
        this.item.photos.splice(this.item.photos.indexOf(key), 1)
      },
      submit () {
        this.$validator
          .validateAll()
          .then((result) => {
            if (result) {
              this.saveItem(this.item.id)
            }
          })
          .catch(err => {
            console.log(err)
          })
      },
      saveItem (itemId = null) {
        let checklistId = this.$route.params.id
        let url = '/checklists/' + checklistId + '/checklist-items'
        let verb = 'post'
        let messageModifier = 'created'
        if (itemId) {
          url = RouteGen.edit('checklist-item', itemId)
          verb = 'patch'
          messageModifier = 'updated'
        }

        server[verb](url, { checklist_item: this.$data.item })
          .then((res) => {
            this.showNotification(201, messageModifier)
            this.$set(this.$data, 'item', res.data.checklist_item)
          })
          .catch((err) => {
            this.showNotification(err.response.status)
          })
      },
      removeCurrentItem (index) {
        if (Policeman.can('delete', 'checklistItem') || !this.item.id) {
          if (confirm('Do you want to delete this check?')) {
            if (this.item.id) {
              let url = RouteGen.delete('checklist-item', this.item.id)
              let messageModifier = 'deleted'
              server.delete(url)
                .then((res) => {
                  this.$emit('remove-checklist-item', index)
                  this.showNotification(200, messageModifier)
                })
                .catch((err) => {
                  this.showNotification(err.response.status)
                })
            }
          }
        }
      },
      showNotification (status, modifier) {
        return this.getMessage(Messages.byStatus(status, 'Inspection-item', modifier))
      }
    },
    notifications: {
      getMessage: {}
    }
  }
</script>

<style lang="sass">
  .item-delete
    cursor: pointer
  .gallery-thumbnail__element
    position: relative
    &__icon
      position: absolute
      z-index: 5
      left: 50%
      transform: translate(-50%, -50%)
      top: 50%
      font-size: 7rem
      opacity: 0.7
  .report-link
    text-decoration: none !important
  .item-status
    margin: 0
    line-height: 0.5rem
</style>



// WEBPACK FOOTER //
// src/components/Checklist/subcomponents/EditItem.vue